import { observer } from 'mobx-react-lite';
import Avatar from '../../../../component/avatar/Avatar';
import ProgressBar from '../../../../component/progressBar';
import { rootStore } from '../../../../mobx/rootStore';
import {
  BottomSection,
  CardMainDiv,
  ChatContent,
  ContentDiv,
  EmptyContent,
  ProgressSection,
  RowDiv,
  StatusText,
  TextDiv,
  Title,
  TopSection,
  UserName
} from './styles';
import { useMemo } from 'react';

const WorkloadCard = () => {
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;

  //Empty message condition
  const renderEmptyMessage = useMemo(() => {
    const openTasks = currentProject?.tasks?.filter((task) => !task.status) || [];
    return openTasks?.length > 0 ? 'No tasks assigned to team.' : 'There is no active task at this moment.';
  }, [currentProject?.tasks]);

  return (
    <CardMainDiv>
      <Title>Team workload</Title>
      {!currentProject?.usersWithWorkload || currentProject?.usersWithWorkload?.length === 0 ? (
        <EmptyContent>{renderEmptyMessage}</EmptyContent>
      ) : (
        <ContentDiv>
          <TopSection>
            <TextDiv>Assignee</TextDiv>
            <TextDiv>Work distribution</TextDiv>
          </TopSection>
          <BottomSection>
            {currentProject.usersWithWorkload.map((member) => (
              <RowDiv key={member.name}>
                <ChatContent>
                  <Avatar imgSrc={member.profile_photo || ''} name={member.name} size={20} />
                  <UserName>{member.name}</UserName>
                </ChatContent>
                <ProgressSection>
                  <ProgressBar
                    percent={Math.round(member.workload)}
                    progressColor={'#5CB176'}
                    height={4}
                    showInfo={false}
                  />
                  <StatusText>{Math.round(member.workload)}%</StatusText>
                </ProgressSection>
              </RowDiv>
            ))}
          </BottomSection>
        </ContentDiv>
      )}
    </CardMainDiv>
  );
};

export default observer(WorkloadCard);
